<div id="task-filter-view" class="page-layout blank">
  <div class="content">
    <div class="left">
      <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-sm="row" fxLayoutAlign.gt-sm="start start">
        <div class="widget" fxFlex="100" fxFlex.gt-sm="100">
          <div class="fuse-card auto-width mb-12 mat-card mat-elevation-z2 p-0" [ngClass.gt-sm]="'mb-0 p-0'">
            <div>
              <div class="p-10 headercmp overflow-hidden" fxlayout="row" fxlayoutalign="space-between center">
                <div class="h3 pr-16 p-b-10 cardHeader float-left">Envio de SMS</div>

                <div class="card-actuation header-actuationr p-10 ">
                  <div class="inner-card p-b-10 ">
                    <button mat-raised-button color="accent" class="m-r-15" (click)="SendSms()">Envio</button>
                    <div *ngIf="IsLoading" class="m-auto">
                      <mat-progress-spinner class="m-auto" [diameter]="50" color="primary" mode="indeterminate">
                      </mat-progress-spinner>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>